import React, { useRef, useEffect } from "react"
import { useLocation } from 'react-router-dom'
import { Button, Checkbox, ConfigProvider, Form, Input, message } from "antd"
import _ from "lodash"
import qs from 'qs'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import WithHOC from "./action"
import CoreRenderFunction from "DisplayCore"
import { LoginLayout } from "PageLayout/Login"
import { getItem, storeItem, clearItem } from 'utils/tokenStore'

import "./index.scss"

const Login = props => {
  let {
    data,
    profile,
    siteInfo,
    onLoadLogin,
    loginRequest,
    setUserProfile
  } = props
  const location = useLocation()
  const [formRef] = Form.useForm()

  useEffect(() => {
    const tokenParam = qs.parse(location.search, { ignoreQueryPrefix: true }).token
    if (!_.isEmpty(tokenParam)) {
      clearItem("IMPERSONATE_TOKEN")
      storeItem('TECHBASE_TOKEN', tokenParam)
      return props.history.push('/dashboard')
    } else if (getItem('TECHBASE_TOKEN')) {
      return props.history.push('/dashboard')
    } else {
      clearItem('IMPERSONATE_TOKEN')
      if (!_.isEmpty(profile)) {
        setUserProfile({})
      }
    }
  })

  let captchaRef = useRef()

  const onSubmitForm = e => {
    // if( captchaRef.current.validateCaptcha( e.captcha ) ){
    loginRequest({ username: e.username, password: e.password, siteDomain: data.ClientReducer.siteInfo.domain })
    // } else {
    //   message.error("Invalid Captcha")
    // }
  }

  const hideComponent = (actionKey) => {
    switch (actionKey) {
      case 'isNotLoginByUsername':
        return siteInfo.login_by !== 'username'
      case 'isNotLoginByMobileNumber':
        return siteInfo.login_by !== 'mobile_number'
      default:
    }
  }

  const goBack = () => {
    props.history.goBack()
  }

  const FooterLayout = {
    type: "footer",
    style: { minHeight: "5vh", color: "#B2B2B2" }
  }

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#006838"
          },
          components: {
            Form: {
              itemMarginBottom: 14,
              marginLG: 14
            }
          },
        }}
      >
        <CoreRenderFunction
          {...props}
          item={LoginLayout}
          hideComponent={hideComponent}
          onSubmitForm={onSubmitForm}
          captchaRef={captchaRef} />
        {
          onLoadLogin && <LoadingOverlay />
        }
        <div
          className="login-continer-mobile relative z-10 flex flex-column align-items-center justify-content-center overflow-hidden"
          style={{
            paddingBottom: "56px",
            paddingTop: "40px"
          }}
        >
          <div className="pc-page-container flex flex-col px-4">

            <div className="row grid flex-column grid-cols-12">
              <div
                className="flex items-center justify-center col-span-12"
                style={{
                  alignItems: 'center',
                  display: "flex",
                  flexDirection: 'column',
                  border: 'white solid 2px',
                  borderRadius: '10px',
                  boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.2)',
                  marginBottom: "26px",
                  padding: "18px 18px 16px 18px",
                  background: "linear-gradient(to bottom, #8DC63F, #8FC743, #98CB51, #A5D268, #B8DB89, #D1E8B2 94%)"
                }}
              >
                <div style={{ width: "100%" }}>
                  <img alt="client-logo" src="/Icons/JomMall_whiteversion_w-tag@3x.png" style={{ width: "100%" }} />
                </div>
                <div style={{ marginTop: '26px', marginBottom: '32px' }}>
                  <p style={{ textAlign: "center", fontSize: '24px', color: '#006838', marginBottom: "0px" }}>Member Login</p>
                </div>
                <Form
                  layout="vertical"
                  className="d-flex flex-column gap-4"
                  style={{ width: "100% " }}
                  form={formRef}
                  onFinish={onSubmitForm}
                >
                  {/* <!-- Forms --> */}
                  <div className="flex flex-col">
                    <Form.Item
                      name="username"
                      className="relative w-100"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Username",
                        },
                      ]}
                    >
                      <Input className="pc-input pc-input--form px-2 py-2" style={{ borderRadius: '30px' }}
                        placeholder="Username" autoFocus
                        suffix={<img src="/Icons/login-page-username-input-icon.svg" />} />
                    </Form.Item>
                  </div>
                  <div className="flex flex-col">
                    <div className="relative  w-100">
                      <Form.Item
                        name="password"
                        className="relative w-100"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your Password"
                          },
                        ]}
                      >
                        <Input.Password
                          className="pc-input pc-input--form px-2 py-2  w-100" style={{ borderRadius: '30px' }} placeholder="********"
                          iconRender={(visible) => (visible ? <img className="w-6" src="/Icons/login-page-password-input-icon-unlock.svg" style={{ width: '17px' }} /> : <img className="w-6" src="/Icons/login-page-password-input-icon.svg" />)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div>
                    <Form.Item>
                      <Checkbox style={{ height: '15px', color: '#006838', fontSize: '13px', fontWeight: 'bold', marginLeft: '10px', marginBottom: '14px' }}>Remember Me</Checkbox>
                    </Form.Item>
                  </div>
                </Form>
                <div style={{ width: "100%" }}>
                  <button
                    type="button"
                    style={{
                      color: '#FFFFFF',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      backgroundColor: '#006838',
                      borderRadius: '30px',
                      width: "100%",
                      marginBottom: "14px"
                    }}
                    onClick={() => formRef.submit()}
                  >
                    LOGIN
                  </button>
                  <button
                    type="button"
                    style={{
                      color: '#FFFFFF',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      backgroundColor: '#DCDCDC',
                      width: "100%",
                      borderRadius: '30px',
                      marginBottom: "12px"
                    }}
                    onClick={() => {
                      goBack()
                    }}
                  >
                    BACK
                  </button>
                </div>
                {/* <!-- Sign Up / Forgot Password --> */}
                <div className="d-flex flex-column align-items-center">
                  {/* <Button
                    type="link"
                    className="text-center"
                    style={{
                      color: '#191C1F',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      fontStyle: 'italic',
                      marginBottom: "10px"
                    }}
                  >
                    Forgot Password?
                  </Button> */}
                  {/* <p style={{ fontSize: '13px', fontWeight: 'bold', fontStyle: 'italic', marginBottom: "0px" }}>
                    <span className="mr-1" style={{ color: '#FFFFFF' }}
                    >Not a Member? </span>
                    <a style={{ color: '#191C1F' }}
                    >Sign Up Now</a>
                  </p> */}
                </div>
              </div>
              <div style={{ width: "180px", paddingLeft: "6px" }}>
                <div
                  class="login-header"
                  style={{
                    fontSize: "24px",
                    color: "#000000",
                    fontWeight: "bold",
                    lineHeight: "normal"
                  }}
                >
                  Now Everyone Can Earn
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "#000000",
                    fontWeight: "bold",
                    marginTop: "18px"
                  }}
                >
                  Achieve your dreams. Your success starts here.
                </div>
              </div>
            </div>
          </div>
          <CoreRenderFunction
            {...props}
            item={FooterLayout}
            hideComponent={hideComponent}
            onSubmitForm={onSubmitForm}
            captchaRef={captchaRef} />
        </div>
      </ConfigProvider>
    </>
  )
}

export default WithHOC(Login)
